import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../features/auth/AuthContext';
import type { Role } from '../../types';
import { Loader2 } from 'lucide-react';

export function ProtectedRoute({
  allowedRoles,
  children,
}: {
  allowedRoles: Role[];
  children: React.ReactNode;
}) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === undefined) {
    return (
      <div className="min-h-screen bg-[#050914] flex items-center justify-center" data-testid="auth-loading">
        <Loader2 className="w-8 h-8 text-cyan-400 animate-spin" strokeWidth={1.5} />
      </div>
    );
  }

  if (user === null) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/?next=${next}`} replace />;
  }

  const hasAccess = user.roles.some((r) => allowedRoles.includes(r));
  if (!hasAccess) {
    const fallback = user.roles.includes('admin') ? '/admin/dashboard' : '/member/dashboard';
    return <Navigate to={fallback} replace />;
  }

  return <>{children}</>;
}
